export default class SyncEventsPushed {
  static type = 'SyncEventsPushed';
  constructor(deviceId, lastPosition) {
    if (typeof deviceId !== 'string') throw new TypeError('deviceId must be a string')
    if (typeof lastPosition !== 'number') throw new TypeError('lastPosition must be a number')
    this.deviceId = deviceId;
    this.lastPosition = lastPosition;
  }
}
